import urlJoin from 'url-join';
const ADFS_IDENTIFIER = 'adfs';

const urlWithRelayState = (redirectionUrl) => {
  const url = encodeURIComponent(window.location.href);
  const baseUrl = encodeURIComponent(urlJoin(window.location.origin, window.baseAppConfig.basePath));
  const encodedRelayState = encodeURIComponent(`RPID=${baseUrl}&RelayState=${url}`);

  return `${redirectionUrl}?RelayState=${encodedRelayState}`;
};

export default function getRedirectionUrl(redirectionLink, isCompleteLink, isOriginRequired, identifier) {
  if (isCompleteLink) {
    return identifier.includes(ADFS_IDENTIFIER) ? urlWithRelayState(redirectionLink) : redirectionLink;
  }

  const originUrl = window.location.origin;
  const loginBackendRoute = `${originUrl}/${redirectionLink}`;

  if (isOriginRequired) {
    const basePath = window.baseAppConfig?.basePath;
    const path = basePath ? basePath : '/';
    const loginRoute = encodeURIComponent(`${originUrl}${path}login`);
    const loginUrlEncodedParams = `auth_origin_url=${loginRoute}&omniauth_window_type=sameWindow`;
    return `${originUrl}/${redirectionLink}?${loginUrlEncodedParams}`;
  }

  return loginBackendRoute;
}
